import React from 'react';
import {Input} from '@flixbus/honeycomb-react';
import LabelWithTooltip from '../LabelWithTooltip/LabelWithTooltip';
import {TooltipInputProps} from './TooltipInput.types';

const TooltipInput: React.FC<TooltipInputProps> = ({
  id,
  name,
  label,
  value,
  step,
  inlineLabelLeft,
  placeholder,
  tooltipContent,
  tooltipPosition,
  disabled,
  valid,
  infoError,
  handleInputChange
}) => {
  return (
    <Input
      id={id}
      name={name}
      label={
        <LabelWithTooltip
          label={label}
          htmlFor={id}
          tooltipProps={{
            id: `tooltip-${id}`,
            content: tooltipContent,
            position: tooltipPosition ?? 'bottom'
          }}
          disabled={disabled}
        />
      }
      inlineLabelLeft={inlineLabelLeft}
      placeholder={placeholder}
      value={value}
      step={step}
      type="number"
      disabled={disabled}
      valid={valid}
      infoError={infoError}
      onChange={e => handleInputChange(e.target.value)}
    />
  );
};

export default React.memo(TooltipInput);
